<div class="manage-container">
    <div class="sub-tabs">
        <div *ngFor="let tab of subTabs"
             class="sub-tab"
             [class.active]="selectedTab === tab.id"
             (click)="onSubTabChange(tab.id)">
            {{ tab.translationKey | translate }}
            <span class="badge" *ngIf="tab.count() > 0">({{ tab.count() }})</span>
        </div>
    </div>

    <div class="tab-content" [ngSwitch]="selectedTab">
        <app-meter-inventory *ngSwitchCase="'inventory'"></app-meter-inventory>
        <app-meter-alerts *ngSwitchCase="'alerts'"></app-meter-alerts>
        <app-meter-unassigned *ngSwitchCase="'unassigned'"></app-meter-unassigned>
        <app-meter-health *ngSwitchCase="'health'"></app-meter-health>
    </div>
</div>
